import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/** Generate a random slug for store email addresses. */
export function generateEmailSlug(): string {
	const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
	let slug = "";
	for (let i = 0; i < 8; i++) {
		slug += chars[Math.floor(Math.random() * chars.length)];
	}
	return slug;
}

/** Format a generated email from a slug. */
export function formatStoreEmail(slug: string): string {
	return `${slug}@sunmerce.com`;
}

/** Truncate text to a max length with ellipsis. */
export function truncate(text: string, maxLength: number): string {
	if (text.length <= maxLength) return text;
	return `${text.slice(0, maxLength)}...`;
}

/** Format currency in USD. */
export function formatCurrency(amount: number): string {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	}).format(amount);
}

/** Format a date string for display. */
export function formatDate(dateString: string): string {
	return new Intl.DateTimeFormat("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
		hour: "numeric",
		minute: "2-digit",
	}).format(new Date(dateString));
}
